import { Box, Layout, Layers, Container as ContainerIcon, Package } from "lucide-react";

const styleMap = {
  static: { label: "Static", Icon: Layout },
  react_spa: { label: "React SPA", Icon: Layers },
  fullstack_farm: { label: "Full-stack", Icon: Box },
  custom_docker: { label: "Custom Docker", Icon: ContainerIcon },
  unknown: { label: "Unknown", Icon: Package },
};

export function StackBadge({ type }) {
  const s = styleMap[type] || styleMap.unknown;
  const Icon = s.Icon;
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs surface-2 text-foreground border border-border">
      <Icon className="h-3.5 w-3.5" />
      {s.label}
    </span>
  );
}
